export const nullableNumber = cv => (isNaN(cv) ? undefined : cv);
